import React from "react"
import { Tooltip } from "react-bootstrap"

const ratmTooltip = (text: string) => (
    <Tooltip id={`ratm-tooltip`}>
        {text}
    </Tooltip>
)

export default ratmTooltip